<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <!-- <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <i class="uil-home-alt"></i> <span> {{ $t('general.reports') }}</span>
            </router-link>
          </li>
          <li>Sınav Raporları</li> -->

          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
                this.$t('report.company_dashboard.reports')
              }}
            </span>
          </li>
          <li>{{ this.$t('general.exam_general_report') }}</li>

        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ $t('general.exam_general_report') }} </span>
        </h2>
      </div>
    </div>
    <!--Modal Profie-->
    <div v-if="error" class="uk-alert-danger mb-3" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color:red;">
        <i class="uil-exclamation-triangle"></i> {{ error }}
      </p>
    </div>
    <!--End Modal Profile -->
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                     class="uk-search-input shadow-0 uk-form-small" type="search"/>
            </div>
          </div>
          <!-- <div>
            <a aria-expanded="false" class="btn btn-icon btn-hover btn-circle" href="javascript:void(0)">
              <i class="uil-search"></i>
            </a>
            <div class="uk-drop" style="left: 91px; top: 159.297px;"
                 uk-drop="mode: hover; pos: right-center; offset: 0">
                <span class="uk-search uk-search-navbar uk-width-1-1">
                  <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                         class="uk-search-input shadow-0 uk-form-small" type="search">
                </span>
            </div>
          </div> -->
          <!-- <h4 class="d-inline-block mb-0"></h4> -->
          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
               href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'id')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'id')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>
            <!-- Filter -->
            <excel-download-button
                :loading="isReportDownloading"
                :tooltipText="$t('filters.export_excell')"
                @download="exportResults"
            />

          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
            <tr>
              <th scope="col">{{ this.$t('general.exam_name') }}</th>
              <th scope="col">{{ this.$t('general.created_at') }}</th>
              <th scope="col">{{ this.$t('general.average_grade') }}</th>
              <th scope="col">{{ this.$t('general.correct_answer_rate') }}</th>
              <th scope="col">{{ this.$t('general.wrong_answer_rate') }}</th>
              <th scope="col">{{ this.$t('general.passing_grade') }}</th>
            </tr>
            </thead>
            <tbody class="list">
            <template v-for="item in formattedItems">
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.created_at }}</td>
                <td>{{ item.exam_avarage.toFixed(2) }}</td>
                <td>{{ item.exam_right_answer_avarage }}</td>
                <td>{{ item.exam_wrong_answer_avarage }}</td>
                <td>{{ item.passmark }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  ERROR,
  GET_ITEMS,
  ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment";
import axios from "axios";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ReportExams",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: { ExcelDownloadButton, Pagination, DefaultLoading},
  data() {
    return {
      pagination: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      sort_by: "id",
      sort_desc: "desc",
      error: null,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      successMessage: "",
      isReportDownloading: false
    };
  },
  computed: {
    items: {
      get() {
        return store.getters[_MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    user_loading: {
      get() {
        return store.getters[_MODULE_NAME + "/" + LOADING];
      },
      set(value) {
      },
    },
    errors: {
      get() {
        return store.getters[_MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    exportResults() {
      if (this.isReportDownloading) {
        return;
      }
      this.isReportDownloading = true;

      axios
          .get(process.env.VUE_APP_BACKEND_APP_URL + "/api/report/export/exams", {
            responseType: "blob",
            params: {
              sort: this.filter.sort,
              order: this.filter.order,
              like: this.filter.search,
              report: Math.random() * 9999999
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.secureLocalStorage("token"),
            },
          })
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            let day = moment().format("YYYYMMDDHHMMSS");
            let fileName = "exam_report_list_" + day + ".xlsx";
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.isReportDownloading = false;
          })
          .catch(() => {
            this.isReportDownloading = false;
          });
    },
    filterResult(filter = null) {
      let self = this;
      this.error = null;
      let filters = {
        like: self.filter.search,
        page: self.page,
        per_page: self.per_page,
        sort: self.filter.sort,
        order: self.filter.order,
      };
      store
          .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
            url: "api/report/exams",
            filters: filters,
          })
          .then((response) => {
            if (response.status) {
              let results = [];
              self.pagination = response.data;

              let items = response.data.data;
              items.forEach((item) => {
                let rightAnswerCount = item.user_results_sum_right_answer_count
                    ? item.user_results_sum_right_answer_count
                    : 0;
                let rightAnswerPercent = rightAnswerCount
                    ? (
                        (rightAnswerCount /
                            item.questions_count /
                            item.user_results_count) *
                        100
                    ).toFixed(2)
                    : 0;

                let wrongAnswerCount = item.user_results_sum_wrong_answer_count
                    ? item.user_results_sum_wrong_answer_count
                    : 0;
                let wrongAnswerPercent = wrongAnswerCount
                    ? (
                        (wrongAnswerCount /
                            item.questions_count /
                            item.user_results_count) *
                        100
                    ).toFixed(2)
                    : 0;

                results.push({
                  name: item.name,
                  created_at: item.created_at
                      ? moment(item.created_at).format("DD/MM/YYYY HH:mm")
                      : "-",
                  exam_avarage: item.user_results_sum_point
                      ? item.user_results_sum_point / item.user_results_count
                      : 0,
                  exam_right_answer_avarage: `${rightAnswerCount} - ${rightAnswerPercent}`,
                  exam_wrong_answer_avarage: `${wrongAnswerCount} - ${wrongAnswerPercent}`,
                  passmark: item.passmark,
                });
              });
              this.formattedItems = results;
            }
          });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;

      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    getFilter(value) {
      this.page = 1;
      this.filterResult(value);
    },
  },
  mounted() {
    this.filterResult();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);

    if (this.$route.params.succesMessage != null) {
      this.successMessage = this.$route.params.succesMessage;
      this.scrollToTop();
    }
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
  },
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
<style>
.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}
</style>
